import { Injectable } from "@angular/core";
import { ListMetadata } from "app/models/list-metadata.model";
import { HttpClientService } from "app/services/httpClient/httpclient.service";
import { AuthService } from "app/services/user/auth.service";
import { Observable } from "rxjs";
import { ParticipantOverviewResponse } from "./challenge.model";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class ChallengeOverviewExportGraphicService {


  //TODO da mettre in index per riconoscerlo e adattarlo alla chiamata

  constructor(
    private http: HttpClientService,
    private httpClient: HttpClient,
    private authService: AuthService
  ) { }


  //----------------CRUD GRAFCI------------------------                            ---
  private exportListUrl = '/k7o/gui-shim/loy/challenge/challenge-report/list';
  private deleteReportUrl = '/k7o/gui-shim/loy/challenge/challenge-report';
  private graphicBaseUrl = '/k7o/gui-shim/loy/challenge/challenge-api/overview';


  //todo da definire tutt ala chiamata

/*   list(
    offset: number | null = null,
    limit: number | null = null,
    search?: Array<{ key: string; value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: ParticipantOverviewResponse[]; metadata: ListMetadata }> {

    const params = HttpClientService.buildListParams(
      offset,
      limit,
      search,
      globalSearch,
      sort,
      sort_dir
    );

    const paramsString = params.toString().replace(/\+/g, '%2B');

    return this.http.getPaged(
      `${this.exportListUrl}?${paramsString}`
    );
  } */

  list(
  offset: number | null = null,
  limit: number | null = null,
  search?: Array<{ key: string; value: string }>,
  globalSearch?: string,
  sort?: string,
  sort_dir?: number
): Observable<{ data: ParticipantOverviewResponse[]; metadata: ListMetadata }> {

let params = HttpClientService.buildListParams(
  offset,
  limit,
  search,
  globalSearch,
  sort,
  sort_dir
);

params = params.set('reportPage', 'DASH_SFIDE');
  const paramsString = params.toString().replace(/\+/g, '%2B');

  return this.http.getPaged(
    `${this.exportListUrl}?${paramsString}`
  );
}

  deleteReport(id: number): Observable<any> {
    return this.http.delete(
      `${this.deleteReportUrl}/${id}`
    );
  }

  obtainReport(id: number): Observable<any> {
    const userCompany = this.authService.user.selectedCompany.toString();
    const token = `Bearer ${this.authService.user.token}`;
    const language = this.authService.sessionHelper.selectedLanguage;
    const headers = new HttpHeaders({
      'Accept-Company': userCompany,
      'Authorization': token,
      'Accept-Language': language
    });

    return this.httpClient.get(
      `${this.graphicBaseUrl}/${id}/download`,
      {
        headers: headers,
        //@ts-ignore
        responseType: 'blob'
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-overview-export-graphic.service.ts